import { NIE_TERMS_AND_CONDITIONS, PROFILE_POLICY } from "../actions/termsconditionsActions";

const initialState = {
    profile_details: {},
    nie_details: {},
};

const termsconditionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case NIE_TERMS_AND_CONDITIONS:
            return {
                ...state,
                nie_details: action.payload,
            };
        case PROFILE_POLICY:
            return {
                ...state,
                profile_details: action.payload,
            };
        default:
            return state;
    }
};

export default termsconditionsReducer;
